// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"15c49c8d","703":"08d84f68"}[chunkId] + ".chunk.js";
};